export default "__VITE_ASSET__4k0uVzQO__"